import request from "@/utils/oms-request";
import download from "@/utils/oms-download";

// 查询客人品牌
export const listCustomerBrand = (customerId: string) =>
    request({
        url: `/brands/${customerId}`,
        method: "get"
    })

// 客人包装资料-列表
export const getPackageInfoList = (params: any) =>
  request({
    url: "/customer-pack-info",
    method: "get",
    params
  });

// 客人品牌状态集
export const queryAllCustomerBrandStates = () =>
  request({
    url: "/customer-pack-info/states",
    method: "get",
  });


// 客人包装资料列表
export const exportCustomerBrandList = () =>
  download({
    responseType: "blob",
    url: `/customer-pack-info/download`,
    method: "get"
  });

// 批量创建品牌模版
export const batchCreateBrandTemplate = () =>
  download({
    responseType: "blob",
    url: `/brands/batch-create`,
    method: "get"
  });
// 批量上传创建品牌
export const batchCreateBrand = (data:any) =>
  request({
    url: `/brands/batch-create`,
    method: "post",
    data
  });

// 品牌管理列表
export const brandList = (params:any) =>
  request({
    url: `/brands`,
    method: "get",
    params
  });

// 客人品牌状态集
export const queryAllBrandSearchStates = () =>
  request({
    url: "/brands/states",
    method: "get",
  });


// 更新品牌备注
export const updateRemark = (id:string,remark:string) =>
  request({
    url: `/brands/${id}/remark`,
    method: "PUT",
    data:{
      remark:remark
    }
  });

// 删除品牌
export const deleteBrand = (id:string) =>
  request({
    url: `/brands/${id}`,
    method: "delete",
  });

// 创建品牌
export const createBrand = (customerId:string,name:string) =>
  request({
    url: `/brands`,
    method: "post",
    data:{
      customerId:customerId,
      name:name
    }
  });

// 作废品牌
export const cancelBrand = (id:string) =>
  request({
    url: `/brands/${id}`,
    method: "PUT"
  });

//  取消作废品牌
export const cancelVoidBrand = (id:string) =>
  request({
    url: `/brands/${id}/cancel-void`,
    method: "PUT"
  });

// 模糊查询品牌
export const findBrandByKeyword = (customerId:string, nameKeyword:string) =>
  request({
    url: "/brands/query-keyword",
    method: "get",
    params:{
      customerId:customerId,
      nameKeyword:nameKeyword
    }
  });


